/**
 * @generated SignedSource<<2d5156121aee930b186eb85bca9ab141>>
 * @relayHash d981a09f9b52974ad96510b34a8aede9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 390a1c7bc3105b9fb99149adb4a6bf01f4b7da346d81dc8ef09d1fd429c9457d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MemoProjectNavigationQuery$variables = {
  cloudId: string;
  first: number;
  isJiraCustomTemplatesUxEnabled: boolean;
  projectAri: string;
  projectIdOrKey: string;
  projectKey: string;
  useProjectKey: boolean;
};
export type MemoProjectNavigationQuery$data = {
  readonly jira: {
    readonly projectDataById?: {
      readonly avatar: {
        readonly large: string | null | undefined;
      } | null | undefined;
      readonly canEditProjectConfig: {
        readonly canPerform: boolean;
      } | null | undefined;
      readonly name: string;
      readonly projectId: string;
      readonly projectKey: string;
      readonly " $fragmentSpreads": FragmentRefs<"CustomTemplateBusinessProjectBanner">;
    } | null | undefined;
    readonly projectDataByKey?: {
      readonly avatar: {
        readonly large: string | null | undefined;
      } | null | undefined;
      readonly canEditProjectConfig: {
        readonly canPerform: boolean;
      } | null | undefined;
      readonly name: string;
      readonly projectId: string;
      readonly projectKey: string;
      readonly " $fragmentSpreads": FragmentRefs<"CustomTemplateBusinessProjectBanner">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"TabsContentProjectNavigation">;
  };
};
export type MemoProjectNavigationQuery = {
  response: MemoProjectNavigationQuery$data;
  variables: MemoProjectNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraCustomTemplatesUxEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectAri"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useProjectKey"
},
v7 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v8 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v9 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "large"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v11 = {
  "alias": "projectKey",
  "kind": "ScalarField",
  "name": "key"
},
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "alias": "canEditProjectConfig",
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "EDIT_PROJECT_CONFIG"
    }
  ],
  "concreteType": "JiraProjectAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canPerform"
    }
  ],
  "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
},
v14 = {
  "condition": "isJiraCustomTemplatesUxEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CustomTemplateBusinessProjectBanner"
    }
  ]
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectAri"
  }
],
v16 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "projectIdOrKey",
    "variableName": "projectIdOrKey"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v18 = {
  "kind": "ScalarField",
  "name": "id"
},
v19 = [
  (v9/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "condition": "isJiraCustomTemplatesUxEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isLiveTemplate"
      }
    ]
  },
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "MemoProjectNavigationQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "TabsContentProjectNavigation"
            },
            {
              "condition": "useProjectKey",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "alias": "projectDataByKey",
                  "args": (v8/*: any*/),
                  "concreteType": "JiraProject",
                  "kind": "LinkedField",
                  "name": "jiraProjectByKey",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "RequiredField",
                      "field": (v10/*: any*/),
                      "action": "THROW",
                      "path": "jira.projectDataByKey.projectId"
                    },
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/)
                  ]
                }
              ]
            },
            {
              "condition": "useProjectKey",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "alias": "projectDataById",
                  "args": (v15/*: any*/),
                  "concreteType": "JiraProject",
                  "kind": "LinkedField",
                  "name": "jiraProject",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    {
                      "kind": "RequiredField",
                      "field": (v10/*: any*/),
                      "action": "THROW",
                      "path": "jira.projectDataById.projectId"
                    },
                    (v11/*: any*/),
                    (v12/*: any*/),
                    (v13/*: any*/),
                    (v14/*: any*/)
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "MemoProjectNavigationQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "navigationItems",
            "args": (v16/*: any*/),
            "concreteType": "JiraNavigationItemConnection",
            "kind": "LinkedField",
            "name": "jwmSavedViewsByProject",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraNavigationItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v18/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isDefault"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeKey"
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isJiraNavigationItem"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      },
                      {
                        "kind": "ClientExtension",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__id"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canRemove"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canSetAsDefault"
                      }
                    ]
                  },
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "alias": "navigationItems",
            "args": (v16/*: any*/),
            "filters": [
              "cloudId",
              "projectIdOrKey"
            ],
            "handle": "connection",
            "key": "tabs_jiraNavigation__navigationItems",
            "kind": "LinkedHandle",
            "name": "jwmSavedViewsByProject"
          },
          {
            "condition": "useProjectKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "projectDataByKey",
                "args": (v8/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": (v19/*: any*/)
              }
            ]
          },
          {
            "condition": "useProjectKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "projectDataById",
                "args": (v15/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProject",
                "plural": false,
                "selections": (v19/*: any*/)
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "390a1c7bc3105b9fb99149adb4a6bf01f4b7da346d81dc8ef09d1fd429c9457d",
    "metadata": {},
    "name": "MemoProjectNavigationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3abf005f31396bd9a49dc75b92325b05";

export default node;
